import React, { useContext, useEffect, useState, useRef } from 'react'
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Row,
} from 'reactstrap'
import NotificationAlert from 'react-notification-alert'
import { Controller, ErrorMessage, useForm } from 'react-hook-form'
import AuthContext from 'context/auth/authContext'
import InputMask from 'react-input-mask'
import { useFormUtils } from 'views/shared/useFormUtils'
import axios from 'axios'

const apiUrl = window.config.apiUrl

const useMyProfile = Id => {
  const [myProfileInfo, setMyProfileInfo] = useState({})
  const [initialProfileInfo, setInitialProfileInfo] = useState({})
  const [loading, setLoading] = useState('false')
  const authContext = useContext(AuthContext)
  const { profileTimeout } = authContext

  useEffect(() => {
    async function getProfile(profileId) {
      try {
        let myProfile
        let initialMyProfile
        let contactsInfo
        let vendorsInfo
        await axios
          .get(`${apiUrl}/contacts/${profileId}`)
          .then(async resContacts => {
            contactsInfo = JSON.parse(resContacts.data.result)[0]
            await axios
              .get(`${apiUrl}/vendors/${contactsInfo.fkVendor}`)
              .then(resVendors => {
                vendorsInfo = JSON.parse(resVendors.data.result)
                myProfile = {
                  ...contactsInfo,
                  ...vendorsInfo[0],
                }
                initialMyProfile = {
                  ...contactsInfo,
                  ...vendorsInfo[0],
                }
                console.log('myProfile is: ' + JSON.stringify(myProfile))
              })
          })
        setMyProfileInfo(myProfile)
        setInitialProfileInfo(initialMyProfile)
        setLoading('true')
      } catch (error) {
        console.log('Failed to load: ' + error)
        setLoading('null')
        profileTimeout()
      }
    }

    if (Id !== '') {
      getProfile(Id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id])

  return [myProfileInfo, initialProfileInfo, loading]
}

const MyProfile = () => {
  const setMyProfile = async MyProfile => {
    try {
      const config = { headers: { 'Content-Type': 'application/json' } }
      await axios
        .put(`${apiUrl}/contacts/${MyProfile.pkContact}`, MyProfile, config)
        .then(response => {
          console.log(
            'CONTACT PUT RESPONSE: ' + JSON.stringify(response.config)
          )
        })
      await axios
        .put(`${apiUrl}/vendors/${MyProfile.fkVendor}`, MyProfile, config)
        .then(response => {
          console.log(
            'CONTACT PUT RESPONSE: ' + JSON.stringify(response.config)
          )
        })
      await notifySuccess()
      return MyProfile
    } catch (e) {
      console.log('Error in setMyProfile: ' + JSON.stringify(e))
      notifyFailure()
    }
  }

  const convertFormat = plainPhone => {
    if (typeof plainPhone === 'undefined' || plainPhone === null)
      return plainPhone
    const phoneDigits = plainPhone.split('')
    if (phoneDigits[0] === '(') return plainPhone
    const formattedPhone =
      '(' +
      phoneDigits[0] +
      phoneDigits[1] +
      phoneDigits[2] +
      ') ' +
      phoneDigits[3] +
      phoneDigits[4] +
      phoneDigits[5] +
      '-' +
      phoneDigits[6] +
      phoneDigits[7] +
      phoneDigits[8] +
      phoneDigits[9]
    return formattedPhone
  }

  const notificationAlert = useRef()
  const notifySuccess = () => {
    let options = {
      place: 'bc',
      message: (
        <div>
          <h5>Successfully updated My Profile info.</h5>
        </div>
      ),
      type: 'success',
      icon: 'nc-icon nc-bell-55',
      autoDismiss: 3,
    }
    notificationAlert.current.notificationAlert(options)
  }
  const notifyFailure = () => {
    let options = {
      place: 'bc',
      message: (
        <div>
          <h5>Failed to updated My Profile info.</h5>
        </div>
      ),
      type: 'danger',
      icon: 'nc-icon nc-bell-55',
      autoDismiss: 3,
    }
    notificationAlert.current.notificationAlert(options)
  }

  const { handleSubmit, control, errors } = useForm()
  const onSubmit = () => {
    myProfileInfo.conOfficePh = myProfileInfo.conOfficePh.replace(/\D/g, '')
    myProfileInfo.conCellPh = myProfileInfo.conCellPh.replace(/\D/g, '')
    setMyProfile(myProfileInfo)
  }

  const { onChangeReviewer } = useFormUtils()

  const userToken = JSON.parse(localStorage.getItem('okta-token-storage'))
  // eslint-disable-next-line no-unused-vars
  const [myProfileInfo, initialProfileInfo, loading] = useMyProfile(
    userToken.accessToken.claims.uid
  )

  return (
    <div className="content">
      <NotificationAlert ref={notificationAlert} />
      {loading === 'false' ? (
        <h2>Searching for your profile</h2>
      ) : loading === 'null' ? (
        <h2>Unable to find your profile</h2>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <Col xs={12}>
            <Card>
              <CardHeader>
                <h5>My Profile</h5>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs={6}>
                    <FormGroup>
                      <p>
                        <strong>First Name</strong>
                      </p>
                      <Controller
                        as={Input}
                        name="FName"
                        defaultValue={myProfileInfo.FName}
                        control={control}
                        rules={{
                          required: {
                            value: true,
                            message: '⚠ First name is required.',
                          },
                          maxLength: {
                            value: 50,
                            message: '⚠ First name exceeds 50 characters.',
                          },
                        }}
                        onChange={([event]) => {
                          onChangeReviewer(myProfileInfo, event)
                          return event
                        }}
                      />
                      <p className={'text-danger'}>
                        <ErrorMessage errors={errors} name="FName" as={'p'} />
                      </p>
                    </FormGroup>
                    <br />
                  </Col>
                  <Col xs={6}>
                    <FormGroup>
                      <p>
                        <strong>Last Name</strong>
                      </p>
                      <Controller
                        as={Input}
                        name="LName"
                        defaultValue={myProfileInfo.LName}
                        control={control}
                        rules={{
                          required: {
                            value: true,
                            message: '⚠ Last name is required.',
                          },
                          maxLength: {
                            value: 50,
                            message: '⚠ Last name exceeds 50 characters.',
                          },
                        }}
                        onChange={([event]) => {
                          onChangeReviewer(myProfileInfo, event)
                          return event
                        }}
                      />
                      <p className={'text-danger'}>
                        <ErrorMessage errors={errors} name="LName" as={'p'} />
                      </p>
                    </FormGroup>
                    <br />
                  </Col>
                </Row>
                <Row>
                  <Col xs={4}>
                    <FormGroup>
                      <p>
                        <strong>Company Name</strong>
                      </p>
                      <Input
                        defaultValue={myProfileInfo?.VendorName || ''}
                        type="text"
                        disabled
                      />
                      <p></p>
                    </FormGroup>
                    <br />
                    <FormGroup>
                      <p>
                        <strong>Street Address</strong>
                      </p>
                      <Controller
                        as={Input}
                        name="VendorStreet"
                        defaultValue={myProfileInfo.VendorStreet}
                        control={control}
                        rules={{
                          required: {
                            value: true,
                            message: '⚠ Street address is required.',
                          },
                          maxLength: {
                            value: 50,
                            message: '⚠ Street address exceeds 50 characters.',
                          },
                        }}
                        onChange={([event]) => {
                          onChangeReviewer(myProfileInfo, event)
                          return event
                        }}
                      />
                      <p className={'text-danger'}>
                        <ErrorMessage
                          errors={errors}
                          name="VendorStreet"
                          as={'p'}
                        />
                      </p>
                    </FormGroup>
                  </Col>
                  <Col xs={4}>
                    <FormGroup>
                      <p>
                        <strong>Primary Phone</strong>
                      </p>
                      <Controller
                        as={Input}
                        type="tel"
                        mask="(999) 999-9999"
                        maskChar=" "
                        tag={InputMask}
                        name="conOfficePh"
                        defaultValue={
                          convertFormat(myProfileInfo?.conOfficePh) || ''
                        }
                        control={control}
                        rules={{
                          pattern: {
                            value: /([(][0-9]{3}[)][ ][0-9]{3}[-][0-9]{4})/,
                            message: '⚠ Invalid phone number',
                          },
                          required: {
                            value: true,
                            message: '⚠ Phone number is required.',
                          },
                        }}
                        onChange={([event]) => {
                          onChangeReviewer(myProfileInfo, event)
                          return event
                        }}
                      />
                      <p className={'text-danger'}>
                        <ErrorMessage
                          errors={errors}
                          name="conOfficePh"
                          as={'p'}
                        />
                      </p>
                    </FormGroup>
                    <br />
                    <FormGroup>
                      <p>
                        <strong>City</strong>
                      </p>
                      <Controller
                        as={Input}
                        name="VendorCity"
                        defaultValue={myProfileInfo?.VendorCity || ''}
                        control={control}
                        rules={{
                          required: {
                            value: true,
                            message: '⚠ City is required.',
                          },
                          maxLength: {
                            value: 25,
                            message: '⚠ City exceeds 25 characters.',
                          },
                        }}
                        onChange={([event]) => {
                          onChangeReviewer(myProfileInfo, event)
                          return event
                        }}
                      />
                      <p className={'text-danger'}>
                        <ErrorMessage
                          errors={errors}
                          name="VendorCity"
                          as={'p'}
                        />
                      </p>
                    </FormGroup>
                  </Col>
                  <Col xs={4}>
                    <FormGroup>
                      <p>
                        <strong>Secondary Phone</strong>
                      </p>
                      <Controller
                        as={Input}
                        type="tel"
                        mask="(999) 999-9999"
                        maskChar=" "
                        tag={InputMask}
                        name="conCellPh"
                        defaultValue={
                          convertFormat(myProfileInfo?.conCellPh) || ''
                        }
                        control={control}
                        rules={{
                          pattern: {
                            value: /([(][0-9]{3}[)][ ][0-9]{3}[-][0-9]{4})/,
                            message: '⚠ Invalid phone number',
                          },
                        }}
                        onChange={([event]) => {
                          onChangeReviewer(myProfileInfo, event)
                          return event
                        }}
                      />
                      <p className={'text-danger'}>
                        <ErrorMessage
                          errors={errors}
                          name="conCellPh"
                          as={'p'}
                        />
                      </p>
                    </FormGroup>
                    <br />
                    <FormGroup>
                      <p>
                        <strong>State</strong>
                      </p>
                      <Controller
                        as={Input}
                        name="VendorState"
                        defaultValue={
                          myProfileInfo?.VendorState?.toUpperCase() || ''
                        }
                        control={control}
                        max={2}
                        rules={{
                          required: {
                            value: true,
                            message: '⚠ State is required.',
                          },
                          maxLength: {
                            value: 2,
                            message: '⚠ State should be 2 characters.',
                          },
                          pattern: {
                            value: /^(?:(A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|P[AR]|RI|S[CD]|T[NX]|UT|V[AIT]|W[AIVY]))$/i,
                            message: '⚠ Invalid state',
                          },
                        }}
                        onChange={([event]) => {
                          onChangeReviewer(myProfileInfo, event)
                          return event
                        }}
                      />
                      <p className={'text-danger'}>
                        <ErrorMessage
                          errors={errors}
                          name="VendorState"
                          as={'p'}
                        />
                      </p>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <FormGroup>
                      <p>
                        <strong>Zip Code</strong>
                      </p>
                      <Controller
                        as={Input}
                        type="numberic"
                        mask="99999"
                        maskChar=" "
                        tag={InputMask}
                        min={0}
                        name="VendorZip"
                        defaultValue={myProfileInfo?.VendorZip || ''}
                        control={control}
                        rules={{
                          pattern: /^\d{5}?$/i,
                          validate: VendorZip => VendorZip.length === 5,
                        }}
                        onChange={([event]) => {
                          onChangeReviewer(myProfileInfo, event)
                          return event
                        }}
                      />
                      <p className={'text-danger'}>
                        <ErrorMessage
                          errors={errors}
                          name="VendorZip"
                          message={'⚠ Zip Code must be 5 characters.'}
                          as={'p'}
                        />
                      </p>
                    </FormGroup>
                  </Col>
                  <Col xs={6}>
                    <FormGroup>
                      <p>
                        <strong>Email Address</strong>
                      </p>
                      <Input
                        defaultValue={myProfileInfo?.conEmail || ''}
                        type="text"
                        disabled
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Button
                  className="btn-round float-right"
                  type={'submit'}
                  color="success"
                >
                  Save
                </Button>
              </CardBody>
            </Card>
          </Col>
        </form>
      )}
    </div>
  )
}

export default MyProfile
